/**
 * Aplicación web Directorio del Ayuntamiento de Zamora.
 * 
 * Desarrollo e implementación: Jaime León Pereira.
 * Ingeniero Informático de la Unidad TIC.
 */
import { useState, useEffect } from 'react';

/**
 * Hook personalizado para detectar dispositivos tablet.
 * Basado en rangos de ancho de ventana típicos de tablets.
 */ 
export default function useVersionTablet() {

  // Estado inicial basado en el ancho actual de ventana
  const [isTablet, setIsTablet] = useState(
    window.innerWidth >= 768 && window.innerWidth <= 992
  );

  useEffect(() => {
    // Función que verifica si el ancho actual está en rango tablet
    const handleResize = () => {
      const width = window.innerWidth;
      setIsTablet(width >= 768 && width <= 992);
    };
    
    // Escuchar cambios de tamaño de ventana
    window.addEventListener('resize', handleResize);

    // Limpiar event listener al desmontar
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return isTablet;
}